/* eslint-disable import/no-anonymous-default-export */
import React, { useState } from 'react';
import Instrument from '../../classes/Instrument';
import Quote from '../../classes/Quote';
import InputBoolean from '../blocks/InputBoolean';
import InputNumber from '../blocks/InputNumber';


interface IProps {
  id: string,
  quote: Quote,
  properties: string[],
  isAlignLeft: boolean[],
  isInput: boolean[],
}


export default function QuoteRow(props: IProps) {
  const [quote, setQuote] = useState(props.quote);

  const getInput = (id: string, quote: Quote, property: string, value: number | string | boolean, isInput: boolean, dp: number) => {
    const key: string = `${id}.${property}:input`;
    switch (isInput) {
      case false:
        return isNaN(Number(value)) ? value : Number(value).toFixed(dp);
      case true:
        switch (typeof (value)) {
          case 'boolean':
            return (<InputBoolean
              id={key}  
              callBack={(value: number | string) => {
                Quote.setProperty(quote, property, value);
                setQuote(quote);
              }}
              value={value as boolean}
            />);            
          case 'string':
          case 'number':
            return (<InputNumber
              id={key}
              callBack={(value: number | string) => {
                Quote.setProperty(quote, property, value);
                setQuote(quote);
              }}
              value={value as number | string}
              dp={dp}
            />);
        }
    };
  }

  const getCell = (id: string, quote: Quote, property: string, isAlignLeft: boolean, isInput: boolean) =>
  (<td key={`${id}:${property}`} className={`text-align-${isAlignLeft ? 'left' : 'right'}`}>
    {getInput(id, quote, property, Quote.getProperty(quote, property), isInput, Quote.getDP(quote as Instrument))}</td>);

  return (<tr key={props.id}>{props.properties.map((property: string, index: number) =>
    getCell(props.id, quote, property, props.isAlignLeft[index], props.isInput[index]))}</tr>);
}